/**
 * Returns the same number with a 2 number of decimal places, if no decimals are present, it will add them (0 by default).
 * Also pads the decimal with 0 for decimals with only one digit.
 * @param num The number to format.
 */
export const formatTo2Decimals = (num: number | null | undefined): string => {
  const value = Number(num)
  if (Number.isNaN(value)) {
    return '0.00'
  }
  return value.toFixed(2)
}
